// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1KsZV","col":"styles_col__35o4p"};